import React from "react";

function RejectBox({state}) {
  return (
    <div className="border bg-white border-[#CBD5E1]  rounded-lg p-5 mt-4">
      <div className=" flex justify-between items-center ">
        <h2 className="text-lg text-[#EF4444] ">Rejected Job</h2>
        <p className="text-sm text-[#6C757D] ">{state?.create_time}</p>
      </div>
      <h3 className="text-sm text-[#6C757D] mt-1 ">
        {state?.reject_reason}
      </h3>
    </div>
  );
}

export default RejectBox;
